<template>
  <div
    class="page"
    :style="{ height: pageHeight }"
  >
    <!-- nav -->
    <div class="nav">
      <div class="nav-title">
        插件分类
      </div>
    </div>

    <!-- content -->
    <div class="grid">
      <div
        v-for="item in sort"
        :key="item.id"
        class="grid-item-box"
        @click="goToSortDetail(item.id, item.name)"
      >
        <div
          class="grid-item"
          :style="{ backgroundColor: item.color }"
        >
          <div class="grid-item-title">
            {{ item.name }}
          </div>
        </div>
        <div
          class="grid-item-after"
          :style="{ backgroundColor: item.color }"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Plugin',
  data() {
    return {
      sort: []
    }
  },
  computed: {
    pageHeight() {
      const tabbarHeight = this.$rpxToPx(60)
      return this.$pxToVw(this.$clientHeight - tabbarHeight) + 'vw'
    }
  },
  watch: {
    // 首页数据
    '$store.state.home.homeConfig'(newValue, oldValue) {
      this.updateData(newValue)
    }
  },
  // 缓存组件show
  activated() {
    this.updateData(this.$store.getters['home/homeConfig'])
  },
  methods: {
    updateData(homeConfig) {
      if (!homeConfig.tags) {
        return
      }
      this.sort = homeConfig.tags
    },
    goToSortDetail(id, title) {
      this.$router.$push({
        name: 'SortDetail',
        params: {
          id
        },
        query: {
          title
        }
      })
    }
  }
}
</script>

<style scoped>
.page {
    width: 375px;
    overflow-x: hidden;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
}
/* nav */
.nav {
    width: 375px;
    height: 60px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    overflow: hidden;
}
.nav-title {
    font-size: 30px;
    font-weight: 900;
    margin-left: 15px;
}

/* content */
.grid {
    width: 375px;
    display: flex;
    flex-wrap: wrap;
    box-sizing: border-box;
    overflow: hidden;
    margin-top: 15px;
}
.grid-item-box {
    position: relative;
    width: 165px;
    height: 123px;
    margin-left: 15px;
}
.grid-item-box:active {
    opacity: 0.5;
}
.grid-item {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
    width: 165px;
    height: 100px;
    border-radius: 15px;
    background-repeat: no-repeat;
    background-size: 100% auto;
}
.grid-item-after {
    position: absolute;
    left: 15px;
    top: 8px;
    z-index: 0;
    width: 135px;
    height: 100px;
    border-radius: 15px;
    opacity: 0.5;
}
.grid-item-title {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 3;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 165px;
    height: 100px;
    color: var(--light100);
    font-size: 20px;
    font-weight: 900;
}
</style>
